'use client';
import { useEffect, useState, useRef } from 'react';
import { useInView } from 'react-intersection-observer';

export default function CountUp({ className, end, duration = 1000 }) {
  const [count, setCount] = useState(0);
  const { ref, inView } = useInView();
  const animationRef = useRef(null);

  useEffect(() => {
    if (inView) {
      let start = count;
      const increment = end / (duration / 10);

      animationRef.current = setInterval(() => {
        start += increment;
        setCount(Math.floor(start));
        if (start >= end) {
          setCount(end);
          clearInterval(animationRef.current);
        }
      }, 10);

      return () => {
        if (animationRef.current) {
          clearInterval(animationRef.current);
        }
      };
    }
  }, [inView, end, duration]);
  return (
    <h1 ref={ref} className={` ${className}`}>
      {count}
    </h1>
  );
}
